var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import * as ApiKey from './ApiKey';
const API_KEY_FIELDS = gql `
  fragment ApiKeyFields on ApiKey {
    id
    name
    key
    expiresAt
    createdAt
  }
`;
const API_KEY_QUERY = gql `
  query ApiKey {
    me {
      apiKeys {
        ...ApiKeyFields
      }
    }
  }
  ${API_KEY_FIELDS}
`;
export const fetchApiKeys = (client) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: API_KEY_QUERY,
        fetchPolicy: 'network-only',
    });
    return data.me.apiKeys.map(ApiKey.fromGQL);
});
const API_KEY_CREATE_MUTATION = gql `
  mutation CreateApiKey($apiKeyInput: ApiKeyAttributes!) {
    createApiKey(input: { apiKey: $apiKeyInput }) {
      apiKey {
        id
        name
        key
        expiresAt
        createdAt
        keyUnmasked
      }
    }
  }
`;
export const createApiKey = (client, apiKeyInput) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.mutate({
        mutation: API_KEY_CREATE_MUTATION,
        variables: {
            apiKeyInput,
        },
    });
    return ApiKey.fromGQL(data.createApiKey.apiKey);
});
//# sourceMappingURL=Api.js.map